/* profileCompleteness — يَفحص اكتمال معلومات المحامي اللازمة للظهور في الدليل العامّ.
   يُعيد قائمة الحقول الناقصة + تَوصيف كلّ حقل بالعربيّة. */

const FIELDS = [
  { key: "phone",          label: "رقم الهاتف",        critical: true,
    hint: "مَطلوب لِيَتَواصل العُملاء معك عبر WhatsApp" },
  { key: "specialty",      label: "التَّخصُّص",         critical: true,
    hint: "اكتب اختصاصك المهنيّ (مَدنيّ، جَزائيّ، أحوال شخصيّة...)" },
  { key: "governorate",    label: "المُحافَظة",         critical: true,
    hint: "تُحدّد ظهورك للعُملاء الباحثين في محافظتك" },
  { key: "bar_id_number",  label: "تَوثيق بِطاقة النِّقابة", critical: true,
    hint: "إجباريّ لِلظهور في الدليل العامّ — امسح بِطاقة النِّقابة في 'حسابي'" },
  { key: "district",       label: "القَضاء",            critical: false,
    hint: "اختياريّ — يُحسّن ظهورك في البحث المحلّي" },
  { key: "bio",            label: "نُبذة قَصيرة",        critical: false,
    hint: "تَعريف موجز عن خِبراتك (حتّى 280 حرفاً)" },
  { key: "avatar_id",      label: "صورة الأَفتار",       critical: false,
    hint: "صورة مُبَكْسَلة تَلتقطها بالكاميرا — لِتَعزيز ثقة العُملاء" },
];

export function computeCompleteness(user) {
  if (!user) return { missing: [], percent: 0, criticalMissing: [], ready: false };
  const missing = [];
  const criticalMissing = [];
  let filled = 0;
  for (const f of FIELDS) {
    const v = (user[f.key] || "").toString().trim();
    if (v) {
      filled += 1;
    } else {
      missing.push(f);
      if (f.critical) criticalMissing.push(f);
    }
  }
  const percent = Math.round((filled / FIELDS.length) * 100);
  const ready = criticalMissing.length === 0;
  return { missing, criticalMissing, percent, ready, total: FIELDS.length, filled };
}

export const COMPLETENESS_FIELDS = FIELDS;
